import React from 'react';
import LibraryBookList from '../components/library-book-list';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import PageHeader from '../components/page-header';
import './page.css';

const LibraryBooksPage = () => (
  <Layout>
    <div className="page">
      <PageHeader
        title="Œuvres"
        description="Créer, éditer ou supprimer des œuvres."
      />

      <div className="page_actions">
        <LinkButton
          className="page_action-button"
          icon="add"
          label="Importer des livres depuis des EANs"
          to="/librairie/importer"
          theme="success"
        />
      </div>

      <LibraryBookList />
    </div>
  </Layout >
);

export default LibraryBooksPage;
